function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M59.183,109.117 c-0.565,0-1.138-0.218-1.604-0.67L41.555,92.982c-0.554-0.534-0.872-1.314-0.872-2.138c0-0.821,0.319-1.604,0.872-2.137 l16.024-15.466c1.042-1.006,2.604-0.862,3.49,0.316c0.887,1.182,0.763,2.952-0.279,3.956l-13.81,13.33l13.81,13.33 c1.042,1.006,1.166,2.776,0.279,3.956C60.581,108.782,59.883,109.117,59.183,109.117z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M90.817,109.117 c-0.7,0-1.397-0.335-1.885-0.986c-0.888-1.18-0.764-2.95,0.278-3.956l13.811-13.33l-13.811-13.33 c-1.042-1.004-1.166-2.774-0.278-3.956c0.887-1.179,2.448-1.322,3.488-0.316l16.025,15.466c0.554,0.533,0.87,1.315,0.87,2.137 c0,0.823-0.316,1.604-0.87,2.138l-16.025,15.465C91.954,108.899,91.383,109.117,90.817,109.117z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M69.326,120.718 c-0.168,0-0.341-0.019-0.513-0.06c-1.337-0.32-2.196-1.809-1.913-3.327l9.986-53.745c0.283-1.515,1.596-2.486,2.934-2.166 c1.341,0.32,2.196,1.809,1.914,3.324l-9.989,53.745C71.502,119.811,70.474,120.718,69.326,120.718z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M133.373,150H16.628 C7.459,150,0,141.546,0,131.154V18.846C0,8.455,7.459,0,16.628,0h116.745C142.542,0,150,8.455,150,18.846v112.309 C150,141.546,142.542,150,133.373,150z M16.628,5.614c-6.438,0-11.676,5.934-11.676,13.232v112.309 c0,7.294,5.238,13.232,11.676,13.232h116.745c6.437,0,11.676-5.938,11.676-13.232V18.846c0-7.298-5.239-13.232-11.676-13.232 H16.628z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M147.524,44.944H2.476 C1.108,44.944,0,43.689,0,42.137c0-1.548,1.108-2.807,2.476-2.807h145.049c1.367,0,2.476,1.259,2.476,2.807 C150,43.689,148.892,44.944,147.524,44.944z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M42.312,31.512 c-4.32,0-7.838-3.986-7.838-8.88c0-4.897,3.518-8.884,7.838-8.884s7.837,3.986,7.837,8.884 C50.148,27.526,46.632,31.512,42.312,31.512z M42.312,19.362c-1.589,0-2.882,1.465-2.882,3.27c0,1.801,1.293,3.267,2.882,3.267 c1.591,0,2.884-1.465,2.884-3.267C45.195,20.827,43.902,19.362,42.312,19.362z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M18.233,31.428 c-4.321,0-7.837-3.984-7.837-8.882s3.516-8.884,7.837-8.884s7.837,3.986,7.837,8.884S22.555,31.428,18.233,31.428z M18.233,19.275 c-1.59,0-2.886,1.47-2.886,3.271s1.296,3.269,2.886,3.269s2.886-1.468,2.886-3.269S19.823,19.275,18.233,19.275z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeWidth: 0.25,
  strokeMiterlimit: 10,
  d: "M66.392,31.599 c-4.322,0-7.838-3.986-7.838-8.884c0-4.894,3.516-8.88,7.838-8.88c4.32,0,7.835,3.986,7.835,8.88 C74.227,27.613,70.712,31.599,66.392,31.599z M66.392,19.446c-1.591,0-2.884,1.468-2.884,3.269c0,1.805,1.293,3.271,2.884,3.271 c1.59,0,2.883-1.466,2.883-3.271C69.274,20.914,67.981,19.446,66.392,19.446z"
}));

function SvgProgramowanieIkona(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramowanieIkona);
export default __webpack_public_path__ + "static/media/programowanie_ikona.30cf1186a4bda9547cd5da6da9475a1a.svg";
export { ForwardRef as ReactComponent };